import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getContactTypes = (): Promise<ISelectModel<number>[]> => {
  return API.get('/api/root/contact-types/all').then(res => res?.data);
};
